var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlobalLayout',[_c('h1',{staticStyle:{"text-align":"center","margin-top":"40rem"}},[_vm._v("开发中，敬请期待！")])])}
var staticRenderFns = []

export { render, staticRenderFns }